// Message types
export const MESSAGE_TYPES = {
    // Messages we send to iframe
    APP_LOGOUT: 'APP_LOGOUT',
    SET_THEME: 'SET_THEME',
    // Messages we receive from iframe
    APP_AUTH_STATUS: 'APP_AUTH_STATUS',
    APP_LOGIN_SUCCESS: 'APP_LOGIN_SUCCESS',
    APP_LOGIN_ERROR: 'APP_LOGIN_ERROR',
    APP_LOGOUT_SUCCESS: 'APP_LOGOUT_SUCCESS',
    APP_LOGOUT_ERROR: 'APP_LOGOUT_ERROR',
};
// Iframe communication class
export class IframeCommunication {
    constructor() {
        this.iframe = null;
        this.messageHandlers = new Map();
        this.isInitialized = false;
        this.setupMessageListener();
    }
    initialize(iframe) {
        this.iframe = iframe;
        this.isInitialized = true;
        console.log('[iframe-communication] Initialized with iframe');
    }
    isReady() {
        return this.isInitialized && this.iframe !== null;
    }
    sendMessage(message) {
        if (!this.isReady()) {
            console.error('[iframe-communication] Cannot send message: iframe not ready');
            return;
        }
        try {
            this.iframe.contentWindow?.postMessage(message, '*');
            console.log('[iframe-communication] Sent message:', message);
        }
        catch (error) {
            console.error('[iframe-communication] Error sending message:', error);
        }
    }
    sendLogout() {
        this.sendMessage({ type: MESSAGE_TYPES.APP_LOGOUT });
    }
    sendTheme(theme) {
        this.sendMessage({
            type: MESSAGE_TYPES.SET_THEME,
            data: { theme }
        });
    }
    onMessage(type, handler) {
        this.messageHandlers.set(type, handler);
    }
    removeMessageHandler(type) {
        this.messageHandlers.delete(type);
    }
    setupMessageListener() {
        window.addEventListener('message', (event) => {
            // In production, you should verify the origin
            // if (event.origin !== 'https://playground.numeriquai.com') return;
            try {
                const message = event.data;
                if (!message || typeof message.type !== 'string') {
                    return;
                }
                console.log('[iframe-communication] Received message:', message);
                const handler = this.messageHandlers.get(message.type);
                if (handler) {
                    handler(message.data);
                }
                else {
                    console.log('[iframe-communication] No handler for message type:', message.type);
                }
            }
            catch (error) {
                console.error('[iframe-communication] Error processing message:', error);
            }
        });
    }
}
// Singleton instance
export const iframeCommunication = new IframeCommunication();
